import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  contentChildren,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { IconComponent } from '@libs/components/icons';
import { AccordionPanelDirective } from './directives';

@Component({
  selector: 'ui-accordion',
  templateUrl: './accordion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['accordion.component.scss'],
  imports: [
    MatExpansionModule,
    IconComponent,
    NgTemplateOutlet,
  ],
})
export class AccordionComponent {
  public readonly multi: InputSignal<boolean> = input(false);
  public readonly panels: Signal<readonly AccordionPanelDirective[]> = contentChildren(AccordionPanelDirective);
}
